import type { SelectProps } from "./Select";
import Select from "./Select";
import type { InputActionMeta } from "react-select";

type MultiSelectProps = SelectProps & {
  disableClearAll?: boolean;
  disableRemove?: boolean;
  disableRemoveCondition?: boolean;
  onInputChange?: (inputValue: string, actionMeta: InputActionMeta) => void;
  required?: boolean;
};

const MultiSelect = ({
  name,
  label,
  errors = null,
  readOnly = false,
  options,
  value,
  onInputChange,
  onChange,
  disableClearAll = false,
  disableRemoveCondition = true, // prevent backspace from removing items when file is open/completed
  widthVariant = "full",
  required,
  ...rest
}: MultiSelectProps) => {
  const components = {
    ...(disableClearAll
      ? {
          ClearIndicator: () => null,
          //MultiValueRemove: () => null,
          DropdownIndicator: () => null,
        }
      : {}),
    // disable X remove button
    ...(disableRemoveCondition
      ? {
          MultiValueRemove: () => null,
        }
      : {}),
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Backspace" || event.key === "Delete") {
      // prevent backspace/delete removal when disableRemoveCondition is true
      if (disableRemoveCondition) {
        event.preventDefault();
        return;
      }

      const target = event.target as HTMLInputElement;
      const inputValue = target.value;

      if (!inputValue && value && Array.isArray(value) && value.length > 0) {
        const newValue = value.slice(0, -1);
        onChange?.(newValue, null);
        event.preventDefault();
      }
    }
  };

  return (
    <Select
      onInputChange={(newValue: string, actionMeta: InputActionMeta) => {
        onInputChange?.(newValue, actionMeta);
      }}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      isMulti={true}
      hideSelectedOptions={true}
      name={name}
      label={label}
      errors={errors}
      options={options || []}
      value={value}
      required={required}
      readOnly={readOnly}
      components={components}
      widthVariant={widthVariant}
      {...rest}
    />
  );
};

MultiSelect.displayName = "MultiSelect";

export default MultiSelect;
